<script setup lang="ts">
const { navIgnoreMainViewGestures } = useGlobals()
const { mainAgentId } = useGlobals()
</script>

<template>
  <div
    :id="mainAgentId"
    class="agent-container"
    :class="[navIgnoreMainViewGestures]"
  >
    <agent-transcript />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.agent-container
  @apply h-full w-full
</style>
